import React from 'react'
import { authRoles } from 'app/auth/authRoles'

export default [{
    path: '/Settings/Brands',
    component: React.lazy(() => import('./BrandSettingsPage')),
    auth: authRoles.admin,
    accessPageName: 'SETTINGS',
}]
